const formatNumber = (value) => {
    let elNewValue = '';
    let textValue = value.toString();
    let counter = 1;
    const elValueIsNumber = Number.isInteger(+value);
    if (elValueIsNumber && +value > 9999) {
        for (let i = textValue.length - 1; i >= 0; i -= 1) {
            elNewValue = textValue[i] + elNewValue;
            if (counter % 3 === 0 && counter > 0) {
                elNewValue = ` ${elNewValue}`;
            }
            counter += 1;
        }
        return elNewValue;
    }

    return value;
}

export default formatNumber;
